import styled from "@emotion/styled";
// Standard sr-only technique: present in the DOM and read by screen readers/simple
// text crawlers, but never visible to sighted users. `display: none`/`visibility: hidden`
// would hide it from assistive tech too and isn't used here on purpose.
export const StyledAgentRecoveryLinksComponent = styled.nav`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
`;
